<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <div class="pa-3">
                <v-row>
                    <v-col cols="12">
                        <h3>เพิ่ม Lot เข้าคลัง</h3>
                        <v-autocomplete hide-details="auto" :items="mat_list" item-text="mat_name" item-value="id" color="primary" @change="searchMaterial" v-model="material_choose" prepend-inner-icon="mdi-magnify" dense outlined></v-autocomplete>
                        <div class="mt-2">
                            <v-form ref="form_add" @submit.prevent="addLotin()">
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th class="text-center border_header_add_lotin_list">

                                            </th>
                                            <th class="text-center border_header_add_lotin_list">
                                                #
                                            </th>
                                            <th class="text-center border_header_add_lotin_list">
                                                วัตถุดิบ
                                            </th>
                                            <th class="text-center border_header_add_lotin_list">
                                                จำนวน
                                            </th>
                                            <th class="text-center border_header_add_lotin_list">
                                                หน่วยนับ
                                            </th>
                                            <th class="text-center border_header_add_lotin_list">
                                                ราคาต่อหน่วย
                                            </th>
                                            <th class="text-center border_header_add_lotin_list">
                                                สรุปรายการ
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(mat_detail,index) in mat_choose_list" :key="index">
                                            <td class="text-center border_header_add_lotin_list" width="10%">
                                                <div class="cursor_icon_add_lotin_list" @click="deleteMaterial(mat_detail.id)">
                                                    <v-icon color="error">mdi-close-circle</v-icon>
                                                </div>
                                            </td>
                                            <td class="text-center border_header_add_lotin_list" width="10%">{{ index + 1 }}</td>
                                            <td class="text-center border_header_add_lotin_list" width="20%">{{ mat_detail.mat_name }}</td>
                                            <td class="text-center border_header_add_lotin_list" width="10%">
                                                <v-text-field type="number" @keypress="isNumberPrice($event)" onpaste="return false" v-model="mat_detail.quantity" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกจำนวน']" required dense outlined></v-text-field>
                                            </td>
                                            <td class="text-center border_header_add_lotin_list" width="20%">
                                                <v-select v-model="mat_detail.unit_type" :items="mat_detail.unit_type_list" item-text="unit_type_name" item-value="id" hide-details="auto" dense outlined>
                                                </v-select>
                                            </td>
                                            <td class="text-center border_header_add_lotin_list" width="10%">
                                                <v-text-field v-if="mat_detail.unit_type == 1" type="number" @keypress="isNumberPrice($event)" onpaste="return false" v-model="mat_detail.price" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกราคาต่อหน่วย']" required dense outlined></v-text-field>
                                                <v-text-field v-if="mat_detail.unit_type == 2" type="number" @keypress="isNumberPrice($event)" onpaste="return false" v-model="mat_detail.price_other" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกราคาต่อหน่วย']" required dense outlined></v-text-field>
                                            </td>
                                            <td class="text-center border_header_add_lotin_list" width="20%">
                                                {{ mat_detail.unit_type == 1 ? currencyFormat(mat_detail.price * mat_detail.quantity) : mat_detail.unit_type == 2 ? currencyFormat(mat_detail.price_other * mat_detail.quantity) : '' }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-center border_header_add_lotin_list pt-2 pb-2" colspan="7">
                                                <v-btn color="#28ab28" type="submit" class="white--text" width="20%" height="50">
                                                    บันทึก
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-form>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <v-dialog v-model="open_alert_show_add" persistent max-width="600">
                <v-card>
                    <v-card-title>
                        สำเร็จ
                    </v-card-title>

                    <v-card-text>
                        เพิ่มวัตถุดิบเข้าคลังเรียบร้อย
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" text @click="confirmSuccess()">
                            ตกลง
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</div>
</template>

<script>
import numberpurchaseorder from '@/api/stock/stocklist/numberpurchaseorder.js'
import {
    currencyFormat
} from '@/helper/numberformat.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            open_alert_show_add: false,
            mat_list: [],
            mat_choose_list: [],
            material_choose: null
        }
    },
    methods: {
        currencyFormat,
        async isNumberPrice(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async searchMaterial(id) {
            const material = this.mat_list.find((detail) => {
                return detail.id == id
            })
            this.mat_list = this.mat_list.filter((detail) => {
                return detail.id != id
            })
            this.mat_choose_list.push({
                id: material.id,
                mat_name: material.mat_name,
                quantity:'',
                unit_type: material.unit_type,
                unit_type_list: material.unit_type_list,
                price_old: material.price,
                price_other_old: material.price_other,
                price: material.price,
                price_other: material.price_other,
            })
        },
        async deleteMaterial(id) {
            const mat_choose_list = this.mat_choose_list.find((detail) => {
                return detail.id == id
            })
            this.mat_list.push({
                id: mat_choose_list.id,
                mat_name: mat_choose_list.mat_name,
                price: mat_choose_list.price_old,
                price_other: mat_choose_list.price_other_old,
                unit_type: 1,
                unit_type_list: mat_choose_list.unit_type_list,
            })
            this.mat_choose_list = this.mat_choose_list.filter((detail) => {
                return detail.id != id
            })
            this.mat_list.sort((a, b) => {
                let fa = a.mat_name.toLowerCase(),
                    fb = b.mat_name.toLowerCase();

                if (fa < fb) {
                    return -1;
                }
                if (fa > fb) {
                    return 1;
                }
                return 0;
            })
            this.material_choose = null
        },
        async addLotin() {
            if (this.$refs.form_add.validate()) {

                if (this.mat_choose_list.length > 0) {

                    this.loading_page = true
                    const mat_id = this.mat_choose_list.map((detail) => {
                        return detail.id
                    })
                    const quantity = this.mat_choose_list.map((detail) => {
                        return parseFloat(detail.quantity)
                    })
                    const unit_id = this.mat_choose_list.map((detail) => {
                        if (detail.unit_type == 1) {
                            return detail.unit_type_list[0].unit_type
                        } else {
                            return detail.unit_type_list[1].unit_type
                        }

                    })
                    const unit_type = this.mat_choose_list.map((detail) => {
                        return detail.unit_type
                    })
                    const price = this.mat_choose_list.map((detail) => {
                        if (detail.unit_type == 1) {
                            return parseFloat(detail.price)
                        } else {
                            return parseFloat(detail.price_other)
                        }

                    })
                    const total = this.mat_choose_list.map((detail) => {
                        if (detail.unit_type == 1) {
                            return parseFloat(detail.price) * parseFloat(detail.quantity)
                        } else {
                            return parseFloat(detail.price_other) * parseFloat(detail.quantity)
                        }
                    })
                    const data = {
                        mat_id: mat_id,
                        quantity: quantity,
                        unit_id: unit_id,
                        unit_type: unit_type,
                        price: price,
                        total: total,
                        total_price: total.reduce((sum, number) => {
                            return sum + parseFloat(number)
                        }, 0),
                    }
                    numberpurchaseorder.addMaterialAddLotin(data).then((response) => {
                        if (response.data.successful === true) {
                            this.open_alert_show_add = true
                            this.loading_page = false
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
            }
        },
        async confirmSuccess() {
            this.$router.push('/stockinout')
        },
    },
    created() {
        numberpurchaseorder.searchMaterial().then((response) => {
            if (response.data.successful === true) {
                this.mat_list = response.data.matList
                response.data.matList.forEach((detail, index) => {
                    this.mat_list[index]['unit_type'] = 1
                    this.mat_list[index]['unit_type_list'] = [{
                        id: 1,
                        unit_type: detail.unit_type,
                        unit_type_name: detail.unit_type_name,
                    }, ]
                    if (detail.unit_other_id) {
                        this.mat_list[index]['unit_type_list'] = [{
                                id: 1,
                                unit_type: detail.unit_type,
                                unit_type_name: detail.unit_type_name,
                            },
                            {
                                id: 2,
                                unit_type: detail.unit_other_id,
                                unit_type_name: detail.unit_other_name,
                            }
                        ]
                    }
                })
                this.loading_page = false
            }
        }).catch((error) => {
            if (error.response.status === 401) {
                this.$store.commit('logOutSuccess')
                this.$router.push('/login')
            }
        })
    }
}
</script>

<style scoped>
.border_header_add_lotin_list {
    border: thin solid rgba(0, 0, 0, 0.12);
}

.cursor_icon_add_lotin_list {
    cursor: pointer;
}
</style>
